import { FormControl, Typography } from '@mui/material';
import styled from 'styled-components';

export const StyledFormControl = styled(FormControl)`
  && {
    .MuiAutocomplete-inputRoot {
      input {
        padding: 0 0.25rem !important;
      }

      .MuiAutocomplete-endAdornment {
        button {
          border-radius: ${({ theme }) => theme.shape.buttonRadius.extraSmall};
        }

        svg {
          color: ${({ theme }) => theme.palette.primary.main};
        }
      }
    }
  }
`;

export const AdditionalInfo = styled(Typography)`
  && {
    padding-right: 0.25rem;
    ${({ theme }) => theme.typography.p10};
    color: ${({ theme }) => theme.palette.text.secondary};
    display: flex;
    flex-direction: row;
    align-items: center;
    gap: 0.25rem;

    & > svg {
      color: ${({ theme }) => theme.palette.text.secondary};
    }
  }
`;
